/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'

import {
  and,
  ControlProps,
  isStringControl,
  RankedTester,
  rankWith,
  schemaMatches
} from '@jsonforms/core'
import { useJsonForms, withJsonFormsControlProps } from '@jsonforms/react'

export const SelectControl: React.FC<ControlProps> = ({
  data,
  schema,
  path,
  label,
  handleChange,
  visible,
  errors,
  required,
  enabled
}) => {
  const [controlClass, setControlClass] = useState('')

  const { core } = useJsonForms()

  useEffect(() => {
    ;(required && !data && core?.validationMode === 'ValidateAndShow') ||
    (!!errors &&
      errors === 'is a required property' &&
      core?.validationMode === 'ValidateAndShow')
      ? setControlClass('is-invalid')
      : setControlClass('')
  }, [errors, data, core?.validationMode])

  return (
    <>
      {visible && (
        <div className=''>
          <Form.Group controlId='formBasicSelect'>
            <Form.Label className='custom-input-label'>{label}</Form.Label>
            <Form.Control
              as='select'
              value={data}
              onChange={(ev) => {
                const val = ev.target.value
                val === 'Please Select'
                  ? handleChange(path, undefined)
                  : handleChange(path, val)
              }}
              className={`${controlClass} custom-select-class`}
              disabled={!enabled}
              data-testid='custom-select'
            >
              <option defaultValue={undefined}>Please Select</option>
              {(schema as any)?.enum.map((option: any) => (
                <option value={option.value} key={option.value}>
                  {option.name}
                </option>
              ))}
            </Form.Control>
            {!!errors && errors === 'is a required property' && (
              <div className='text-danger'>
                <span>Please select an option</span>
              </div>
            )}
          </Form.Group>
        </div>
      )}
    </>
  )
}

export const selectControlTester: RankedTester = rankWith(
  100, //increase rank as needed
  and(
    isStringControl,
    schemaMatches((schema: { hasOwnProperty: (arg0: string) => any }) =>
      // eslint-disable-next-line no-prototype-builtins
      schema.hasOwnProperty('isCustomSelect')
    )
  )
)

export default withJsonFormsControlProps(SelectControl)
